"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';

import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import bfcban1 from '../images/lightningcategory/bfc_page_banner.jpg';
import bfcban1_360 from '../images/lightningcategory/bfc_page_banner_360.jpg';
import bfcban1_tab from '../images/lightningcategory/bfc_page_banner_tab.jpg';
import bfcban1_2x from  '../images/lightningcategory/bfc_page_banner@2x.jpg';
import Bfcdetailscontent from '../components/Bfcdetailscontent';
const BFCPage = () => {
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Earthing backfill compound — lowers soil resistivity for stable earth resistance" apostropheBefore="" apostropheAfter="" ban1x={bfcban1} ban2x={bfcban1_2x} ban360={bfcban1_360} bantab={bfcban1_tab}/>
           <ProductsubMenu/>
          
           <Bfcdetailscontent/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default BFCPage
 
